export default __webpack_public_path__ + "static/media/drone8.826933c2.jpg";